module.exports = __webpack_public_path__ + "img/end_season_8.ac46d266.png";